var _defs, _g, _g2, _g3, _g4, _g5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRelaxingCocktail(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 300 300",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ffcc01;}.cls-2{fill:#f4d69e;}.cls-3,.cls-4{fill:#ff927c;}.cls-3{opacity:0.4;}.cls-5{fill:#f1c374;}.cls-14,.cls-21,.cls-6{fill:#1b434c;}.cls-10,.cls-20,.cls-7,.cls-8,.cls-9{fill:none;}.cls-7,.cls-9{stroke:#dbe5e5;}.cls-10,.cls-20,.cls-7,.cls-8{stroke-miterlimit:10;}.cls-10,.cls-7,.cls-8,.cls-9{stroke-width:6.71px;}.cls-10,.cls-8{stroke:#a8c0c8;}.cls-9{stroke-miterlimit:12;}.cls-10,.cls-24{opacity:0.3;}.cls-11,.cls-19,.cls-24,.cls-25{fill:#a8c0c8;}.cls-12{fill:#266275;}.cls-13,.cls-22{fill:#fff;}.cls-14{opacity:0.5;}.cls-15{fill:#dbe5e5;}.cls-16{fill:#e8f5f4;}.cls-17{fill:#91e6e1;opacity:0.41;}.cls-18{fill:#8fa5aa;opacity:0.37;}.cls-19{opacity:0.22;}.cls-20{stroke:#1b434c;stroke-width:3px;}.cls-21{opacity:0.1;}.cls-22{opacity:0.2;}.cls-23{fill:#53b8e5;}.cls-25{opacity:0.15;}.cls-26{opacity:0.04;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_7",
    "data-name": "Layer 7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M240.45,53.39c0,14.65-12.13,28.11-26.78,28.11S184.76,69.63,184.76,55s11.88-28.11,26.52-28.11S240.45,38.75,240.45,53.39Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Face"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M38.08,95.17C39.19,93,133.22,76.49,134.48,79c1.53,3.08,10.15,109.53,10.15,109.53l-91.14,7.19S37.45,96.42,38.08,95.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M87.66,194.63c-.41-.63-5.38-10.77-5.8-14.91s.63-1.65-5-6.83-7-13.45-8.07-16.35-12,.39-12.86-5.61,0-8.9.62-10.35-.6-9.29-2.87-13.64-7.66-14.07-4.14-20.28S71.31,94.45,75.24,94.45s40.36-4.35,44.92,19.25,2.48,53,2.48,53-20.08,26.08-20.7,26.7S87.66,194.63,87.66,194.63Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "108.74 146.88 175.3 140.81 175.66 152.57 114.81 158.1 108.74 146.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "231.22 234.79 169.94 195.52 109.55 234.23 97.12 168.61 103.01 167.49 113.78 224.39 169.94 188.4 225.22 223.82 225.22 191.89 231.22 191.89 231.22 234.79"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M42.38,63.46c1.73-3,86.62-16.7,90-13.79,3.64,3.16,8.09,41.81,5.4,47.71-1,2.23-87.06,18.82-88.8,17.1C45.31,110.88,40.15,67.34,42.38,63.46Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "226.93 141.06 255.07 141.06 242.98 152.93 242.32 169.2 247.81 173.6 233.74 173.6 239.9 168.98 239.24 152.71 226.93 141.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M266.2,180.65H215.1c-1.82,0-2.28-5.92-1-7.22.88-.9,52-1.33,53.1,0S268,180.65,266.2,180.65Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "242.98 228.96 238.64 228.96 237.64 178.23 243.98 178.23 242.98 228.96"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M235.94,225H246.3a3,3,0,0,1,3,3v1a0,0,0,0,1,0,0H232.94a0,0,0,0,1,0,0v-1A3,3,0,0,1,235.94,225Z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_19",
    "data-name": "Layer 19"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M90.43,170.16c.5.19.16,17.81,7,17.81s52.08-.38,52.08-.38-3.75-16.31-9.56-28.68C133.16,144.51,90.43,170.16,90.43,170.16Z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_11",
    "data-name": "Layer 11"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "182.71 191.89 182.71 234.79 131.87 202.25 121.36 195.52 110.85 202.25 60.89 234.23 54.83 202.25 52.99 192.55 48.45 168.61 54.34 167.49 59.09 192.55 60.93 202.25 65.13 224.39 99.71 202.25 114.86 192.55 121.36 188.39 127.86 192.55 143.01 202.25 176.71 223.82 176.71 191.89 182.71 191.89"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 127.34,
    y1: 148.3,
    x2: 127.34,
    y2: 148.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 59.92,
    y1: 132.88,
    x2: 59.92,
    y2: 132.88
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 59.92,
    y1: 132.88,
    x2: 59.92,
    y2: 132.88
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "50.09 178.55 51.93 188.25 45.83 188.25 43.99 178.55 50.09 178.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "127.86 192.55 143.01 202.25 131.87 202.25 121.36 195.52 110.85 202.25 99.71 202.25 114.86 192.55 127.86 192.55"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 176.71,
    y: 192.55,
    width: 6,
    height: 9.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 53.49,
    y: 187.53,
    width: 177.83,
    height: 8.91
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M146.17,169.9s3.8,1.87,4.31,5.55,4.22,9.55,1.5,12.13h-4.54l-2.67-16.06Z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-9",
    points: "136.22 183.07 171.17 162.15 201.67 161.21"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 136.22,
    y1: 183.08,
    x2: 163.87,
    y2: 166.52
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 195.96,
    y: 154.16,
    width: 18.96,
    height: 6.56,
    rx: 3.28,
    transform: "translate(-35.74 251.39) rotate(-58.75)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 161.82,
    y1: 97.94,
    x2: 146.55,
    y2: 87.56
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-9",
    points: "145.17 128.29 171.61 116.5 161.82 97.94 155.21 82.13"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 145.17,
    y1: 128.29,
    x2: 163.59,
    y2: 120.13
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M129,127.59a2.26,2.26,0,0,1,1.36-2.7l21.5-8.52a2.4,2.4,0,0,1,3.07,1.23l4.21,9.19a2.39,2.39,0,0,1-.94,3L136.41,144a2.28,2.28,0,0,1-3.45-1.32Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 40.51,
    y1: 129.5,
    x2: 49.5,
    y2: 113.36
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-9",
    points: "69.02 149.13 40.1 150.47 40.51 129.5 39.32 112.4"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 69.02,
    y1: 149.13,
    x2: 48.9,
    y2: 150.11
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M83.2,141.22a2.29,2.29,0,0,0-2.44-1.8l-23,2.05a2.4,2.4,0,0,0-2.19,2.47l.36,10.11a2.38,2.38,0,0,0,2.21,2.3l25.79,2.88a2.29,2.29,0,0,0,2.49-2.74Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 131.34,
    y1: 147.7,
    x2: 131.34,
    y2: 147.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 51.8,
    y1: 139.72,
    x2: 51.8,
    y2: 139.72
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 51.8,
    y1: 139.72,
    x2: 51.8,
    y2: 139.72
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M79.92,144.34s8.88,30,11.49,31.66,50.74-12.82,52.71-16.24-6.61-31.38-7.2-32.15S79.92,144.34,79.92,144.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M93.48,139.49l.09.3s1.91,9.87,3.26,10.71c.84.52,15.19-16.31,15.19-16.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M135.68,127.14l.07.3s3.16,9.51,2.41,11c-.47.91-21-5.73-21-5.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M123,143.38c.91,2.89.13,4-1.75,4.54s-3.73.37-4.57-1.79a3.9,3.9,0,0,1,2.13-4.94A3.19,3.19,0,0,1,123,143.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M126.93,154.42c.92,2.89.14,4-1.75,4.55s-3.73.36-4.56-1.79a3.89,3.89,0,0,1,2.13-5A3.19,3.19,0,0,1,126.93,154.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M138.47,132.15c-7.07,3.31-24.47,9.63-36.26,12.92-9.9,2.77-15.07,3.92-20.86,4.09-1.3-4.18-1.44-4.82-1.44-4.82s56.41-17.5,57-16.73C137.09,127.84,137.4,128.6,138.47,132.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M151.19,100.84c-1.72.38-3.51.58-3.51.58l-6.45-24.21s2-.78,3.91-1.37A53.83,53.83,0,0,1,151.19,100.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M150.94,122.64c-1.87,4.28-15.21,7.7-39,14.36-23.38,6.55-39.69,10.69-43.35,7.56C58.3,135.75,44.91,82.87,46.76,79.4c2.07-3.86,11.26-8,21.34-11.65l.79-.29c2.52-.91,4.83-1.77,7-2.58,4.51-1.69,8.39-3.13,12.32-4.27,5.44-1.59,13.23-3.71,20.93-5.36h0l1-.22c4.38-.93,8.55-1.79,12.15-2.31,5.28-.75,9.37-.76,11.21.83C138.86,58.2,154.56,114.35,150.94,122.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M145.23,119.47c-.83,2.11-4.72,3.9-11.51,6q-2.85.9-6.38,1.91c-2.69.77-5.66,1.59-8.92,2.5l-3.44.95-1.19.34-1.35.37-.67.19-1.28.35-2,.54-3.06.83-.09,0-1,.26-1.88.5-.92.23-.75.19c-1.67.43-3.26.82-4.77,1.18l-.85.2-.43.1-.82.18h0c-8.08,1.79-13.49,2.29-15.29.64a16.18,16.18,0,0,1-2.74-3.56C70.3,124.2,64.06,103.38,61.19,90.6c-1.27-5.65-1.87-9.73-1.48-10.55,2.93-6,22.69-11.77,33.49-14.9s32.64-9.49,37.11-5.36c.93.87,2.25,3.66,3.72,7.62C139.61,82.36,147.43,113.83,145.23,119.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M145.23,119.47c-.83,2.11-4.72,3.9-11.51,6q-2.85.9-6.38,1.91c-2.69.77-5.66,1.59-8.92,2.5l-3.44.95-1.1.31-1.44.4-.67.19-1.28.35-2,.54-3.06.83-.09,0-1,.26-1.88.5-.92.23-.75.19c-1.67.43-3.26.82-4.77,1.18l-.85.2-.43.1-.82.18h0c-8,1.77-13.4,2.26-15.2.61a18.11,18.11,0,0,1-2.83-3.53C70.3,124.2,64.06,103.38,61.19,90.6a33.53,33.53,0,0,1,14-6.27c9-1.32,17.72,1.58,26.84-1s11.9-10.22,18.27-13.39c7.9-3.93,12-2.86,13.72-2.5C139.61,82.36,147.43,113.83,145.23,119.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M122.26,52.72c-2.5,5.47-8.53,15.61-19.66,18.43-11.32,2.89-21.89-3-26.72-6.27,4.51-1.69,8.39-3.13,12.32-4.27,5.44-1.59,13.23-3.71,20.93-5.36h0l1-.22C114.49,54.1,118.66,53.24,122.26,52.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M61.49,129s3.63,10.09,7,13.34,8-2.25,7.95-3.15A199.62,199.62,0,0,1,57.53,79.92a1.78,1.78,0,0,0-2.22-1.45l-5.38,1.41a1.81,1.81,0,0,0-1.34,1.83C48.8,86,50.4,99.93,61.49,129Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M48,116c2.24,6.74,6.19,11.5,8.82,10.63L62.05,125c2.63-.87,2.94-7,.7-13.79s-6.19-11.51-8.82-10.64l-5.28,1.63C46,103,45.71,109.22,48,116Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M48,116c2.24,6.74,6.19,11.5,8.82,10.63L62.05,125c2.63-.87,2.94-7,.7-13.79-2.9-8.73-6.19-11.51-8.82-10.64l-5.28,1.63C46,103,45.71,109.22,48,116Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-15",
    cx: 52.71,
    cy: 114.39,
    rx: 5.01,
    ry: 12.87,
    transform: "translate(-33.39 22.46) rotate(-18.38)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M127.18,109.24a15.24,15.24,0,0,1-20.76,5.82"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-6",
    cx: 97.73,
    cy: 102.87,
    rx: 3.13,
    ry: 9.8,
    transform: "translate(-21.36 25.72) rotate(-13.53)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-6",
    cx: 126.77,
    cy: 95.88,
    rx: 3.13,
    ry: 9.8,
    transform: "translate(-18.92 32.33) rotate(-13.53)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M118.82,96.28c-3.64,1.15-11,3.19-14.74,4C98,101.64,79.54,105.36,80,106.85c.45,1.67,3.89,7.3,7.42,9.06a14.14,14.14,0,0,0,7.2,1.5,13.93,13.93,0,0,0,3-.48,14.32,14.32,0,0,0,10.39-11.58,4,4,0,0,1,2.9-3.27l2.62-.71a4,4,0,0,1,4.16,1.35,14.31,14.31,0,0,0,11.84,5.21,13.93,13.93,0,0,0,3-.48c7.64-2.07,11.34-13,10.08-17.6C142.1,88.36,124.67,94.44,118.82,96.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M120.19,94.33c-3.64,1.15-11,3.18-14.75,4-6.1,1.35-24.53,5.07-24.13,6.56.46,1.67,3.9,7.29,7.42,9.06a14.08,14.08,0,0,0,7.2,1.49,13.3,13.3,0,0,0,3-.47A14.36,14.36,0,0,0,109.3,103.4a4,4,0,0,1,2.9-3.28l2.61-.71a4,4,0,0,1,4.16,1.36,14.37,14.37,0,0,0,4.64,3.71,14.08,14.08,0,0,0,7.2,1.49,13.3,13.3,0,0,0,3-.47c7.64-2.08,11.34-13,10.08-17.6C143.46,86.41,126,92.48,120.19,94.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M94.85,100.64c.13,2.07-.09,5.57-2.53,7.54-3,2.39-3.47,4.49-3.59,5.77a14.1,14.1,0,0,0,7.21,1.51,13,13,0,0,1,2.93-6.77c1.87-1.92,2.67-6.65,3.14-9.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M129.73,91.22c.12,2.08-.1,5.52-2.53,7.48-3,2.39-3.47,4.49-3.59,5.77a14.09,14.09,0,0,0,7.2,1.51,13.25,13.25,0,0,1,2.95-6.77c2-2,2.77-7.32,3.23-10.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M137.87,167.21s7.08,2.21,8.41,3.14-1.23,8.44,2.1,10.7,1.51,6.53,1.51,6.53l-15.49.08s-5-1.69-5.18-2.49,1.2-5.58,1.2-5.58Z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-9",
    points: "116.58 183.07 151.53 163.15 174.14 185.82"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M130,169.21s-4.39,10.24,2.26,12.24-12.1,5.05-12.5,5.19-4.93.13-4.93.13l-8.11-9.05,12-6.25,9.18-4.12Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 168.41,
    y: 181.02,
    width: 18.96,
    height: 6.56,
    rx: 3.28
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_17",
    "data-name": "Layer 17"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "37.29 161.57 103.84 155.51 104.21 167.26 43.35 172.79 37.29 161.57"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M57.35,260.93s35.18-2.33,40.57,2.27,5,4.26,12.59,4.92,12.41,3.94,5.23,8.53,23,7.38,37.12,7.63,20.7,10.75-32.81,2.88-41.84-17.42-51.94-17.42C46.12,269.74,52.62,261.69,57.35,260.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M53,266.27l9.92-4.09s17.84-15.49,6.56-14.48-11,3.45-10,5.31,1.34,3.19-3,6.58-3.81,5.62-3.81,5.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M109.11,257c0,3.51-12.28,6.36-27.43,6.36s-21-2.85-21-6.36,5.86-6.37,21-6.37S109.11,253.48,109.11,257Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M216.16,247.1c-37.87,0-49.84,5.91-31.62,10.88s25.12,8.08,2.59,11.52-76.57,2.65-55.13,7.81c11.4,2.74,53.89-.18,78,5.58S268.81,275,246,269.76c-23.3-5.37-20.36-13.67,2.65-13.67C272.62,256.09,265.89,247.1,216.16,247.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M268.36,236.15v6.3H44.59V231.66c1.58-2,4.81-.36,7-1.49A3,3,0,0,0,52.83,229H256.38c2.23,3.63,7.56-.7,8.89,4A3.92,3.92,0,0,0,268.36,236.15Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-24",
    x: 44.59,
    y: 237.49,
    width: 223.78,
    height: 4.97
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M91,247.1c30,0,63.69-.45,67.7,3.46s-8.45,8,14.29,10.49-37.19,6.51-53.93,2S114,254.11,91,253.63C67.15,253.14,39.92,247.1,91,247.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M135.84,238.56H44.59v-6.9c1.58-2,4.81-.36,7-1.49,1.54.55,27.05,1.35,28.17,2.53,3.59,3.78,6.94-4,18.28-.37,10.8,3.48,23.28-1.4,35.9,5.15C134.57,237.81,135.21,238.17,135.84,238.56Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-26"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M112.89,230v11.49H101.16V230h11.73m.9-.9H100.26v13.29h13.53V229.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M99.36,230v11.49H87.62V230H99.36m.9-.9H86.72v13.29h13.54V229.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M85.76,230v11.49H74V230H85.76m.9-.9H73.12v13.29H86.66V229.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M72.16,230v11.49H60.43V230H72.16m.9-.9H59.53v13.29H73.06V229.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M126.43,230v11.49H114.69V230h11.74m.9-.9H113.79v13.29h13.54V229.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M140,230v11.49H128.23V230H140m.9-.9H127.33v13.29h13.53V229.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M153.5,230v11.49H141.76V230H153.5m.9-.9H140.86v13.29H154.4V229.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M167,230v11.49H155.3V230H167m.9-.9H154.4v13.29h13.53V229.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M180.57,230v11.49H168.83V230h11.74m.9-.9H167.93v13.29h13.54V229.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M194.1,230v11.49H182.37V230H194.1m.9-.9H181.47v13.29H195V229.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M207.64,230v11.49H195.9V230h11.74m.9-.9H195v13.29h13.54V229.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M221.18,230v11.49H209.44V230h11.74m.9-.9H208.54v13.29h13.54V229.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M234.71,230v11.49H223V230h11.73m.9-.9H222.08v13.29h13.53V229.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M248.25,230v11.49H236.51V230h11.74m.9-.9H235.61v13.29h13.54V229.1Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M102.72,266.84s-7.56-3.46.11-5c3.31-.67,3.61.52,24.24,2.53s-12.92-11.19-12.92-11.19l-5-.84s-10,5.39-10.62,5.75-2.51,1.19-3.07,2.47,0,5.13,0,5.13Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRelaxingCocktail);
export default __webpack_public_path__ + "static/media/relaxing_cocktail.3d31ded8f7a3b28330bbc31c9b929754.svg";
export { ForwardRef as ReactComponent };